import script from "./MortgagePayment.vue?vue&type=script&lang=ts&setup=true"
export * from "./MortgagePayment.vue?vue&type=script&lang=ts&setup=true"

import "./MortgagePayment.vue?vue&type=style&index=0&id=05b74ee7&lang=scss"

const __exports__ = script;

export default __exports__